import {CollectionSubTypes} from 'types';
import type {SearchCountResultDto, SeriesCountResult} from '../types';

export const mapSeriesCountResponseDto = (
  dto: SearchCountResultDto,
): SeriesCountResult => {
  const result: SeriesCountResult = {};
  for (let i = 0; i < CollectionSubTypes.length; i++) {
    result[CollectionSubTypes[i]] = dto.responses[i].hits.total.value;
  }
  return result;
};
